import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconMinusMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"minus-medium, remove, delete"} maskId="square-filled-radius-0-stroke-1-IconMinusMedium"><path fillRule="evenodd" clipRule="evenodd" d="M4.5 11.5H19.5V12.5H4.5V11.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconMinusMedium;
